import { Timestamp } from 'firebase/firestore' 

// convert from date object to yyyy-mm-dd
export const dateObjToDateStr = (dateObj, type) => { 

  const year = dateObj.getFullYear()
  const month = (dateObj.getMonth() + 1).toString().padStart(2, '0') // Months are 0-based 
  const day = dateObj.getDate().toString().padStart(2, '0') 
  const hours = String(dateObj.getHours()).padStart(2, '0')
  const minutes = String(dateObj.getMinutes()).padStart(2, '0')
  const seconds = String(dateObj.getSeconds()).padStart(2, '0')

  if (type === 'detailed') {
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  }
  if (type === 'long') {
    return `${year}-${month}-${day}T${hours}:${minutes}` //:${seconds}
  } else {
    return `${year}-${month}-${day}`
  }
}

export const dateObjToTimestamp = (dateObj) => {
  /*const timestamp = dateObj.getTime()
  return timestamp*/
  return Timestamp.fromDate(dateObj)
}

export const timestampToDateObj = (timestamp) => {
  
  if (!timestamp) {
    return new Date('1888-08-08')
  }
  // If timestamp is a valid Firebase Timestamp object
  if (timestamp instanceof Timestamp) {
    return timestamp.toDate()
  }
  // If timestamp has `seconds` (standard or raw format)
  if(timestamp.seconds) {
    return new Date(timestamp.seconds * 1000)
  }
  // Check for `_seconds` and `_nanoseconds` (raw Firestore format)
  if (timestamp._seconds && timestamp._nanoseconds !== undefined) {
    return new Date(timestamp._seconds * 1000 + Math.floor(timestamp._nanoseconds / 1e6)); // Convert nanoseconds to milliseconds
  }

  
  // fallback to create a Date from Timestamp directly
  return new Date(timestamp)
}

export const timestampToDateStr = (timestamp, type) => {
  if (!timestamp) {
    return '1888-08-08'
  }
  const dateObj = timestampToDateObj(timestamp)
  //const dateObj = timestamp instanceof Timestamp ? timestamp.toDate() : new Date(timestamp)
  //const dateObj = new Date(timestamp)
  return dateObjToDateStr(dateObj, type)
}

// convert from yyyy-mm-dd to timestamp
export const dateStrToTimestamp = (dateStr) => {
  const dateObj = new Date(dateStr)
  /*const timestamp = dateObj.getTime()
  return timestamp*/
  return Timestamp.fromDate(dateObj)
}

export const dateStrToDateObj = (dateStr) => {
  const dateObj = new Date(dateStr)
  return dateObj
}
// yyyy-mm-dd add based on frequency and return date object
export const calculateDateObj = (dateObj, freq, freqUnit, minus) => {

  const freqNum = Number(freq)
  const newDateObj = new Date(dateObj.getTime())

  switch(freqUnit) {
    case 'hours':
    case 'hour':
      newDateObj.setHours(minus ? newDateObj.getHours() - freqNum : newDateObj.getHours() + freqNum)
      break
    case 'days':
    case 'day':
      newDateObj.setDate(minus ? newDateObj.getDate() - freqNum : newDateObj.getDate() + freqNum)
      break
    case 'weeks':
    case 'week':
      newDateObj.setDate(minus ? newDateObj.getDate() - freqNum * 7 : newDateObj.getDate() + freqNum * 7)
      break
    case 'months':
    case 'month':
      newDateObj.setMonth(minus ? newDateObj.getMonth() - freqNum : newDateObj.getMonth() + freqNum)
      break
    case 'years':
    case 'year':
      newDateObj.setFullYear(minus ? newDateObj.getFullYear() - freqNum : newDateObj.getFullYear() + freqNum)
      break
    default:
      throw new Error ('Invalid frequency unit')
  }
  
  // Subtract one day for year, month, week, and day frequencies 
  if (['days', 'day', 'weeks', 'week', 'months', 'month', 'years', 'year'].includes(freqUnit)) { 
    newDateObj.setDate(minus ? newDateObj.getDate() + 1 : newDateObj.getDate() - 1)
  }
  return newDateObj
}
// return a number of days between 2 dates difference
export const diffDateObj = (startDate, endDate) => {

  // Convert milliseconds to days
  const differenceInDays = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24))

  return differenceInDays

}